import React, { useState } from "react";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import { isEmpty } from "../../utility";

const SubForm = ({ status, message, onValidated }) => {
  const [subScribe, setSubScribe] = useState({
    email: "",
    fname: "",
  });
  const [subScribeE, setSubScribeE] = useState({
    email: "",
    fname: "",
  });
  const [validator, setValidator] = useState(false);

  function sumbitForm() {
    if (checkInput) {
      subScribe.email &&
        subScribe.fname &&
        subScribe.email.indexOf("@") > -1 &&
        onValidated({
          EMAIL: subScribe.email,
          FNAME: subScribe.fname,
        });
    }
  }
  const checkInput = () => {
    let isModalerror = false;
    if (isEmpty(subScribe?.fname) || subScribe?.fname.length < 3) {
      setSubScribeE((prevState) => ({
        ...prevState,
        fname: "Full Name is required and must be at least 3 characters",
      }));
      isModalerror = true;
    }

    let mailformat =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (isEmpty(subScribe?.email) || !mailformat.test(subScribe?.email)) {
      setSubScribeE((prevState) => ({
        ...prevState,
        email: "Plese Provide a Valid Email Address",
      }));
      isModalerror = true;
    }

    if (isModalerror) {
      setValidator(false);
    } else {
      setValidator(true);
    }
    return true;
  };

  const handleChange = (e) => {
    setSubScribe((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    checkInput();
  };

  return (
    <>
      {" "}
      <div>
        <li>
          <div className="input-group input-group-icon">
            <input
              value={subScribe.fname}
              className="footInput"
              type="text"
              placeholder="Full Name"
              onChange={handleChange}
              name="fname"
              autoComplete="off"
            />
            <div className="input-icon">
              <i className="fa fa-user"></i>
            </div>
          </div>
        </li>
        <li>
          <div className="input-group input-group-icon">
            <input
              value={subScribe.email}
              className="footInput"
              type="email"
              placeholder="Email Adress"
              onChange={handleChange}
              name="email"
              autoComplete="off"
            />
            <div className="input-icon">
              <i className="fa fa-envelope"></i>
            </div>
          </div>
        </li>
        <li>
          {!status ? (
            <button
              className="btn p-2 buttan"
              type="submit"
              disabled={!validator}
              onClick={sumbitForm}
            >
              Subscribe
            </button>
          ) : (
            ""
          )}
        </li>
        {status === "sending" && (
          <button className="btn p-2 buttan" disabled type="submit">
            Sending
          </button>
        )}
        {status === "error" && (
          <button
            className="btn p-2 buttan"
            disabled
            type="submit"
            style={{ bacgroundColor: "red", color: "white" }}
          >
            {message}
            {window.location.reload()}
          </button>
        )}
        {status === "success" && (
          <>
            <button
              className="btn p-2 buttan"
              disabled
              type="submit"
              style={{ bacgroundColor: "green", color: "white" }}
            >
              Subscribed!
            </button>
            {window.location.reload()}
          </>
        )}
      </div>
    </>
  );
};

export default SubForm;
